import React from 'react';
import type { BoxT } from '@mentimeter/ragnar-ui/box';
import { Box } from '@mentimeter/ragnar-ui/box';

type CanvasElementWrapperProps = Omit<BoxT, 'p' | 'px' | 'pt'>;

export const NonInteractiveVisualizationWrapper = React.forwardRef(
  (props: CanvasElementWrapperProps, ref) => {
    return <Box p="space4" {...props} ref={ref} />;
  },
);
